const SITE_KEY = '6LeF55EqAAAAABPXlaCQwA1oN_uruTb9JJwvLWzN';

let scriptPromise = null;

export const loadRecaptcha = () => {
  if (window.grecaptcha?.execute) {
    return Promise.resolve(window.grecaptcha);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha));
      script.onerror = () => {
        scriptPromise = null;
        script.remove();
        reject(new Error('Failed to load reCAPTCHA'));
      };
      document.head.appendChild(script);
    });
  }

  return scriptPromise;
};

export const executeRecaptcha = async (action) => {
  const grecaptcha = await loadRecaptcha();
  return grecaptcha.execute(SITE_KEY, { action });
};
